<template>
  <div class="table_wrap member">
    <span class="total_length pb10">총 {{ paginationData.total }}개 </span>
    <el-table class="list-table" header-cell-class-name="list-header"
              style="width: 100%;" height="695" empty-text="데이터가 없습니다."
              :data="competitionData"
    >
      <el-table-column
          class="table_no"
          type="index"
          label="No"
          width="90"
          class-name="num text-center"
          :index="tableIdx"
      >
      </el-table-column>
      <el-table-column
          label="상태" width="90" class-name="text-center">
        <template slot-scope="scope">
          <span>{{ returnStatus(scope.row.c_status) }}</span>
        </template>
      </el-table-column>
      <el-table-column
          label="카테고리" width="90" class-name="text-center">
        <template slot-scope="scope">
                    <span>
                        {{ returnCategoryName(scope.row.ic_idx) }}
                    </span>
        </template>
      </el-table-column>
      <el-table-column label="공모전명" width="" class-name="text-center" prop="c_title"></el-table-column>
      <el-table-column label="총상금" width="" class-name="text-center" prop="c_prize">
        <template slot-scope="scope">
                    <span>
                        {{ returnCommas(scope.row.c_prize) }} M (₩ {{ returnCommas(scope.row.c_prize) }})
                    </span>
        </template>
      </el-table-column>
      <el-table-column label="응모기간" width="" class-name="text-center" prop="c_end_time">
        <template slot-scope="scope">
                    <span>
                        {{ returnDateFormat(scope.row.c_end_time,'YYYY-MM-DD HH:mm') }}
                    </span>
        </template>
      </el-table-column>
      <el-table-column label="발표일" width="" class-name="text-center" prop="c_release_time">
        <template slot-scope="scope">
                    <span>
                        {{ returnDateFormat(scope.row.c_release_time,'YYYY-MM-DD HH:mm') }}
                    </span>
        </template>
      </el-table-column>
      <el-table-column label="등록일시" width="" class-name="text-center" prop="created_at">
        <template slot-scope="scope">
                    <span>
                        {{ returnDateFormat(scope.row.created_at,'YYYY-MM-DD HH:mm') }}
                    </span>
        </template>
      </el-table-column>
      <el-table-column
          label="옵션" width="" class-name="text-center">
        <template slot-scope="scope">
          <div class="row-info ">
            <div class="row-info pointer" @click="moveDetail(scope.row.c_idx)">
              [상세]
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {categoryType} from "@/service/competitionService";
import dateMixins from "@/mixins/dateMixins";
export default {
  name: "CompetitionListUserLayout",
  mixins: [dateMixins],
  components: {},
  inject: [],
  provide() {
    return {}
  },
  props: {
    competitionData: {
      type: Array,
      default: () => {
        return []
      }
    },
    paginationData: {
      type: Object,
      default: () => {
        return {total: 0, page: 0, size: 0,}
      }
    },
  },
  data() {
    return {
      idx: 1,
      categoryType: categoryType
    }
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    moveDetail(idx) {
      this.$router.push(`/competition/list/${idx}`);
    },
    tableIdx(index) {
      return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
    },
    returnStatus(status) {
      switch (status) {
        case 0 : {
          return '진행예정'
        }
        case 1 : {
          return '진행중'
        }
        case 2 : {
          return '심사중'
        }
        case 3 : {
          return '발표완료'
        }
        default : {
          return ''
        }
      }
    },
    returnCategoryName(value) {
      let keys = Object.keys(this.categoryType)
      let category = keys.filter(category => Number(category) === value);
      return this.categoryType[category].name
    },
    returnCommas(x=0) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>
